import { AuthService } from '#services';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized',
  imports: [TranslatePipe],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
  standalone: true,
})
export class UnauthorizedComponent {
  private _authService = inject(AuthService);
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);

  constructor() {
    if (this._authService.isAuthenticated()) {
      const redirectTo = this._route.snapshot.queryParams['returnUrl'] || '/';
      this._router.navigateByUrl(redirectTo);
    }
  }
}
